import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Ingredient } from '../../shared/models/ingredient.model';
import {
  PaginatedResult,
  PaginationFilter,
} from '../../shared/models/pagination.model';
import { CrudService } from '../../shared/models/crud-service.model';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class IngredientService implements CrudService<Ingredient> {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = environment.backendUrl + 'ingredients';

  loadWithFilter(
    filter: PaginationFilter
  ): Observable<PaginatedResult<Ingredient>> {
    let httpParams = new HttpParams()
      .set('page', filter.page.toString())
      .set('limit', filter.limit.toString());

    if (filter.search) {
      httpParams = httpParams.set('search', filter.search);
    }

    return this.http.get<PaginatedResult<Ingredient>>(this.apiUrl, {
      params: httpParams,
    });
  }

  loadById(id: string): Observable<Ingredient> {
    return this.http.get<Ingredient>(`${this.apiUrl}/${id}`);
  }

  create(ingredient: Omit<Ingredient, 'id'>): Observable<Ingredient> {
    return this.http.post<Ingredient>(this.apiUrl, { name: ingredient.name });
  }

  update(id: string, ingredient: Partial<Ingredient>): Observable<Ingredient> {
    return this.http.patch<Ingredient>(`${this.apiUrl}/${id}`, ingredient);
  }

  delete(id: string): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }

  deleteMany(ids: string[]): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}`, {
      body: {
        ids,
      },
    });
  }

  generateImage(ingredientId: string): Observable<string> {
    return this.http.post(
      `${this.apiUrl}/${ingredientId}/image`,
      {},
      { responseType: 'text' }
    );
  }

  getTotalCount(): Observable<{ total: number }> {
    return this.http.get<{ total: number }>(`${this.apiUrl}/count`);
  }
}
